import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { UserRole } from 'src/types/enum/user-role';
import { MeiliSearchResponse } from 'src/types/responses/meilisearch';
import { calculatePaginationOffset } from 'src/utils/calculate-pagination-offset';
import meiliSearchApiClient from '../../../../../api/clients/meilisearch';
import tenantApi from '../../../../../api/clients/tenant';
import { Admin } from '../types/admin';

export const fetchAdmins = async (
  tenantToken: string,
  searchState: SearchState,
  page: number,
  perPage: number,
): Promise<MeiliSearchResponse<Admin>> => {
  const { data } = await meiliSearchApiClient.post<MeiliSearchResponse<Admin>>(
    `/indexes/TenantAdmin-${tenantToken}/search`,
    {
      ...searchState,
      limit: perPage,
      offset: calculatePaginationOffset(page, perPage),
    },
  );

  return data;
};

export const removeAdmin = async (token: string): Promise<void> => {
  const { data } = await tenantApi.delete(`/admins/${token}`);

  return data;
};

export const inviteAdmin = async (
  email: string,
  phoneNumber: string | undefined,
  role: UserRole,
): Promise<Admin> => {
  const { data } = await tenantApi.post<Admin>(`/admins`, {
    email,
    phoneNumber,
    role,
  });

  return data;
};

export const resendAdminInvitation = async (token: string): Promise<void> => {
  await tenantApi.post(`/admins/${token}/resend`);
};

export const updateAdminPhoneNumber = async (
  token: string,
  phoneNumber: string,
): Promise<void> => {
  await tenantApi.put<Admin>(`/admins/${token}/contact`, {
    phoneNumber,
  });
};

export const updateAdminRole = async (
  token: string,
  role: UserRole,
): Promise<Admin> => {
  const { data } = await tenantApi.post<Admin>(`/admins/${token}/role`, {
    role,
  });

  return data;
};
